import { Checkbox } from "@/components/ui/checkbox";

const propertyTypesDisplayNames = {
  studio: "Apartaestudio",
  apartment: "Apartamento",
  warehouse: "Bodega",
  house: "Casa",
  medical_office: "Consultorio",
  building: "Edificio",
  farm: "Finca",
  room: "Habitación",
  hotel: "Hotel",
  commercial_space: "Local",
  lot: "Lote",
  office: "Oficina",
  parking: "Parqueadero",
};

type PropertyTypeSelectorProps = {
  propertyTypes: string[];
  onPropertyTypeToggle: (propertyType: string) => void;
};

export const PropertyTypeSelector = ({
  propertyTypes,
  onPropertyTypeToggle,
}: PropertyTypeSelectorProps) => {
  return (
    <div>
      <p className="mb-2 text-sm font-medium">Tipos de propiedad</p>
      <div className="flex flex-col">
        {Object.entries(propertyTypesDisplayNames).map(([key, displayName]) => (
          <label key={key} className="flex min-h-11 items-center gap-2 py-2 text-sm">
            <Checkbox
              checked={propertyTypes.includes(key)}
              onCheckedChange={() => onPropertyTypeToggle(key)}
              className="size-3.5"
            />
            {displayName}
          </label>
        ))}
      </div>
    </div>
  );
};
